import React, { FunctionComponent } from "react";
import { PredictionSelect, PredictionSelectType } from "/src/ui/challengesRegistration/prediction/PredictionSelect"
import makeStyles from '@mui/styles/makeStyles';
import { useTranslation } from "react-i18next";

export const NostraPrediction: FunctionComponent = () => {
    const classes = useStyles();
    const { t } = useTranslation();
    
    return (
        <>
            <div>
                { t('prediction') }
            </div>
            <PredictionSelect
                quantity={ 24 }
                type={ PredictionSelectType.HOURS }
            />
            <PredictionSelect
                quantity={ 60 }
                type={ PredictionSelectType.MINUNES }
                required
            />
            <PredictionSelect
                quantity={ 60 }
                type={ PredictionSelectType.SECONDS }
                required
            />
            <input className={classes.predictionInput} name="prediction" type="text"/>
        </>
    )
}

const useStyles = makeStyles({
    predictionInput: {
        display: "none"
    }
})
